import { render } from "./DisplayDemo.vue?vue&type=template&id=58dc7073"
const script = {}

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__